module.exports = __webpack_public_path__ + "static/img/icon_interpage_orchid.png";